import {
  Card,
  CardHeader,
  Checkbox,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material'
import { handleToggle, handleToggleAll, numberOfChecked } from '../utils'

const CustomList = ({ title, items, checked, setChecked }) => {
  return (
    <Card sx={{ boxShadow: '1px 2px 6px 0px rgb(57 85 120 / 11%)', border: '1px solid #e1d9fb' }}>
      <Divider />
      <CardHeader
        sx={{
          px: 2,
          py: 1,
          backgroundColor: '#AEADFA',

          '& .MuiCardHeader-title': {
            fontSize: '14px',
            fontWeight: '600',
            color: '#27104E',
          },
          '& .MuiCardHeader-subheader': {
            fontSize: '12px',
            color: '#414762',
          },
        }}
        avatar={
          <Checkbox
            sx={{ marginRight: '0px' }}
            onClick={handleToggleAll(items, checked, setChecked)}
            checked={numberOfChecked(items, checked) === items.length && items.length !== 0}
            indeterminate={
              numberOfChecked(items, checked) !== items.length &&
              numberOfChecked(items, checked) !== 0
            }
            color="primary"
            disabled={items.length === 0}
            inputProps={{
              'aria-label': 'all items selected',
            }}
          />
        }
        title={title}
        subheader={`${numberOfChecked(items, checked)}/${items.length} selected`}
      />
      <Divider />
      <List
        sx={{
          width: 240,
          height: 230,
          bgcolor: 'background.paper',
          overflow: 'auto',
        }}
        dense
        component="div"
        role="list"
      >
        {items
          .sort((a, b) => a.sequence - b.sequence)
          .map((value) => {
            const labelId = `transfer-list-all-item-${value}-label`
            return !value.is_hidden ? (
              <ListItem
                key={value.path}
                role="listitem"
                button
                onClick={handleToggle(value, checked, setChecked)}
              >
                <ListItemIcon className="hidecolumn-checkbox">
                  <Checkbox
                    sx={{ minWidth: '40px' }}
                    checked={checked.findIndex((it) => it.path == value.path) !== -1}
                    color="primary"
                    tabIndex={-1}
                    disableRipple
                    inputProps={{
                      'aria-labelledby': labelId,
                    }}
                  />
                </ListItemIcon>
                <ListItemText
                  className="hidecolumn-subspantext"
                  id={labelId}
                  primary={value.name}
                />
              </ListItem>
            ) : null
          })}
      </List>
    </Card>
  )
}

export default CustomList
